import axios from 'axios';
import GlobalErrorHandler from './globalErrorHandler';

const BASE_URL = process.env.REACT_APP_CLIENT_URL;
const client = axios.create({ baseURL: BASE_URL });

const BASE_URL_BACKOFFICE = process.env.REACT_APP_BACKOFFICE_URL;
const clientBackoffice = axios.create({ baseURL: BASE_URL_BACKOFFICE });

/**
 * Global Response Interceptor
 * Handles HTTP 429 (Rate Limit) and 423 (Account Locked) responses
 */
const setupInterceptors = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      // Handle rate limiting (429) and account lockout (423) globally
      if (error?.response?.status === 429 || error?.response?.status === 423) {
        const message = error?.response?.data?.message || 'Too many requests. Please wait before trying again.';
        
        // Store error in sessionStorage for global alert display
        sessionStorage.setItem('globalRateLimitError', JSON.stringify({
          type: 'error',
          message: message,
          timestamp: new Date().getTime(),
        }));

        // Dispatch custom event for listeners (Footer component, etc.)
        window.dispatchEvent(new CustomEvent('rateLimitError', { detail: { message } }));
      }
      return error;
    }
  );
};

// Setup interceptors for all axios instances
setupInterceptors(client);
setupInterceptors(clientBackoffice);
setupInterceptors(axios);

export const request = ({ ...options }) => {
  const onSuccess = (response) => response;
  const onError = (error) => {
    GlobalErrorHandler.handleError(error);
    return error;
  };
  return client(options).then(onSuccess).catch(onError);
};

export const axiosPrivate = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
  withCredentials: true,
});
setupInterceptors(axiosPrivate);

export default axios.create({ baseURL: BASE_URL });

export const requestBackoffice = ({ ...options }) => {
  const onSuccess = (response) => response;
  const onError = (error) => {
    GlobalErrorHandler.handleError(error);
    return error;
  };
  return clientBackoffice(options).then(onSuccess).catch(onError);
};
